<template
  @click:outside="closeThisMenu"
>
  <v-menu
    v-model="isMenuOpen"
    bottom
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        @click="clickEdit"
      >
        <v-list-item-title>
          <v-icon
            left
            small
          >
            mdi-pencil
          </v-icon>
          Modifica
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        @click="clickDelete"
      >
        <v-list-item-title>
          <v-icon
            left
            small
          >
            mdi-delete
          </v-icon>
          Elimina
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: 'GroupDocumentsMenu',
  props: {
    showMenu: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isMenuOpen: false,
    }
  },
  watch: {
    showMenu(newVal) {
      this.isMenuOpen = newVal
    },
    isMenuOpen(newVal) {
      if (newVal === false) {
        this.$emit('closeMenu')
      }
    },
  },
  methods: {
    clickEdit() {
      this.$emit('clickEdit')
    },
    clickDelete() {
      this.$emit('clickDelete')
    },
    closeThisMenu() {
      this.$emit('closeMenu')
    },
  },
}
</script>
